<template>
  <div>
    <div v-if="model && model[prop] === true" class="rounded-pill" style="background-color: #F49536">
      <font-awesome-icon v-if="model && model[prop] === true" :icon="['far', 'bell-ring']" class="px-3 fa-xl" style="color: #FDECD8"  transform="shrink-2"></font-awesome-icon>
<!--      <font-awesome-icon v-else :icon="column.fieldConfig.falseIcon" class="fa-xl"></font-awesome-icon>-->
    </div>
  </div>
</template>
<script>

import SessionManager from "@/utils/SessionManager";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";

export default {
  name: "BellNotificationRenderer",
  mounted() {
  },

  methods: {},

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({

  })

};
</script>
